export const COLLAPSED_PREVIEW_QUESTIONNAIRE_IDS = ['CGH-Q001', 'KKH-Q001'];

export const UPCASE_DISCLAIMER_TEXTS = [
  'Epilepsy',
  'Anaesthetics',
  '(general anaesthesia)',
  '(regional anaesthesia)',
  'stroke',
  'Kidney disease',
  'Hepatitis',
  'Cirrhosis',
  'Sleep apnoea',
  'Chronic bronchitis',
  'chronic obstructive pulmonary disease (COPD)',
  'cardiac pacemaker',
  'cardioverter-defibrillator',
  'An electrocardiogram (ECG)',
  'Allergies',
  'Gastric reflux',
  'heartburn',
];

export const PREGNANCY_RIGHT_QUESTIONNAIRE_ID = 'KKH-OBS';
export const PREOPERATIVE_ANAESTHESIA_QUESTIONNAIRE_ID = 'CGH-Q001';
export const CHILD_DEVELOPMENT_PRE_VISIT_QUESTIONNAIRE_ID = 'SHP-Q003';
export const TRAVEL_MEDICINE_VACCINATION_PRE_VISIT_QUESTIONNAIRE_ID = 'SHP-Q005';
export const DIABETIC_QUESTIONNAIRE_ID = 'SHP-Q004';
export const WELL_WOMEN_QUESTIONNAIRE_ID = 'SHP-Q001';

export const OBSTETRICS_APPOINTMENT_QUESTIONNAIRE_ID = 'KKH-OBS-PRIV';
export const KKH_QUESTIONNAIRE_IDS = [PREGNANCY_RIGHT_QUESTIONNAIRE_ID, OBSTETRICS_APPOINTMENT_QUESTIONNAIRE_ID];

export const PRE_QUESTIONNAIRE_SECTION_ANCHOR_KEY = 'pre-questionnaire';
